import * as layout from '../../components/markLayout.module.css';
import Table, { TableColumn } from '@hero/ui-kit/tables/Table';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import Tag from '@hero/ui-kit/components/Tag';
import type { Membership, MembershipStatus } from '../../types';
type Props = {
    memberships: Membership[];
};
const statusTagType = (status: MembershipStatus) => {
    switch (status) {
        case 'ACTIVE':
            return 'success' as const;
        case 'PENDING':
            return 'warn' as const;
        case 'CANCELLED':
            return 'fail' as const;
    }
};
const columns: TableColumn<Membership>[] = [
    {
        colKey: 'organization',
        name: 'Organization',
        align: 'left',
        headAlign: 'left',
        render: (m) => <P noDefaultMargin>{m.organization_name || '—'}</P>
    },
    {
        colKey: 'type',
        name: 'Type',
        align: 'left',
        headAlign: 'left',
        render: (m) => <P noDefaultMargin>{m.membership_type || '—'}</P>
    },
    {
        colKey: 'status',
        name: 'Status',
        align: 'left',
        headAlign: 'left',
        render: (m) => (
            <Tag type={statusTagType(m.status)} size="small">
                {m.status}
            </Tag>
        )
    },
    {
        colKey: 'roles',
        name: 'Roles',
        align: 'left',
        headAlign: 'left',
        render: (m) => <P noDefaultMargin>{m.roles.map((r) => r.role).join(', ') || '—'}</P>
    }
];
const MembershipsList: React.FC<Props> = ({ memberships }) => {
    if (memberships.length === 0) {
        return <P noDefaultMargin>No memberships.</P>;
    }
    return (
        <div
            style={{
                overflowX: 'auto'
            }}
            className={layout.tableScroll}
        >
            <Table columns={columns} data={memberships} rowKey="membership_id" emptyValues="—" />
        </div>
    );
};
export default MembershipsList;
